import ResponderAlertModal from 'features/Responder/components/ResponderAlertModal';
import React, { useCallback, useMemo, useRef, useState } from 'react';

const DEFAULT_CONFIRM_CONFIG = {
  title: 'Confirm',
  message: '',
  confirmLabel: 'Confirm',
  cancelLabel: 'Cancel',
  showCancel: true,
  confirmVariant: 'danger',
  cancelVariant: 'primary',
};

const DEFAULT_ALERT_CONFIG = {
  title: 'Notice',
  message: '',
  confirmLabel: 'OK',
  showCancel: false,
  confirmVariant: 'primary',
  cancelVariant: 'primary',
};

const useResponderDialog = () => {
  const [dialogConfig, setDialogConfig] = useState(null);
  const resolverRef = useRef(null);

  const closeDialog = useCallback((result) => {
    const resolve = resolverRef.current;
    resolverRef.current = null;
    setDialogConfig(null);
    if (typeof resolve === 'function') resolve(result);
  }, []);

  const openDialog = useCallback(
    (config) =>
      new Promise((resolve) => {
        if (typeof resolverRef.current === 'function') {
          resolverRef.current(false);
        }
        resolverRef.current = resolve;
        setDialogConfig(config);
      }),
    [],
  );

  const confirm = useCallback(
    (overrides = {}) => openDialog({ ...DEFAULT_CONFIRM_CONFIG, ...overrides }),
    [openDialog],
  );

  const showAlert = useCallback(
    (overrides = {}) => openDialog({ ...DEFAULT_ALERT_CONFIG, ...overrides }),
    [openDialog],
  );

  const dialogElement = useMemo(
    () =>
      dialogConfig ? (
        <ResponderAlertModal
          show
          title={dialogConfig?.title}
          message={dialogConfig?.message}
          confirmLabel={dialogConfig?.confirmLabel}
          cancelLabel={dialogConfig?.cancelLabel}
          showCancel={!!dialogConfig?.showCancel}
          confirmVariant={dialogConfig?.confirmVariant}
          cancelVariant={dialogConfig?.cancelVariant}
          onConfirm={() => closeDialog(true)}
          onCancel={() => closeDialog(false)}
        />
      ) : null,
    [closeDialog, dialogConfig],
  );

  return {
    confirm,
    showAlert,
    dialogElement,
  };
};

export default useResponderDialog;
